import React from 'react';
import { TwoColumns } from './TwoColumns';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { clone, uniqBy } from 'lodash';
import classNames from 'classnames';
import { localize } from '../Util/L10n';
import { withRouter } from 'react-router-dom';
import DraggableModule from './DraggableModule';
import { getSessionModules, setSessionModules } from '../Util/Module';

class ElectiveModules extends React.Component {
  constructor(props) {
    super(props);
    const { semester } = props.match.params;

    this.state = {
      modules: this.flatModules(),
      currentTypes: [],
      ...getSessionModules(semester),
      selectedModules: this.selectedModules(),
      selectedInGroups: [],
      dragging: null,
    };
  }

  componentDidMount = () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
      const dropzones = document.querySelector('.dropzones').parentElement;
      this.setState({
        dropzoneHeight: dropzones.offsetHeight,
      });
    }
  };

  electiveModules = () => {
    return this.props.modules.map((module) => module.coreElectiveModules);
  };
  flatModules = () => {
    const modules = this.electiveModules().flat();
    return uniqBy(modules, 'uid');
  };
  selectedModules = () => {
    return Object.values(this.props.selectedModules)
      .map((module) => {
        return Object.values(module);
      })
      .flat();
  };

  groupModules = (modules) => {
    return modules.reduce((obj, value) => {
      if (!obj[value.modulegroups[0].name])
        obj[value.modulegroups[0].name] = { modules: [] };
      obj[value.modulegroups[0].name].modules.push(value);
      obj[value.modulegroups[0].name].uid = value.modulegroups[0].uid;
      return obj;
    }, {});
  };

  getInactiveModulesGrouped = () => {
    const modules = this.state.modules.filter(
      (module) => !this.state.selected.includes(module.uid)
    );
    return this.groupModules(modules);
  };
  getActiveModulesGrouped = () => {
    const modules = this.state.modules.filter((module) =>
      this.state.selected.includes(module.uid)
    );
    return this.groupModules(modules);
  };
  groupIsSatisfied = (group, groupName) => {
    const mGroup = this.getMandatoryGroups(group);
    if (mGroup !== undefined) {
      const activeModules = this.getActiveModulesGrouped()[groupName];
      if (
        activeModules === undefined ||
        activeModules.modules.length < mGroup.amount
      ) {
        return true;
      }
      return false;
    }
    return true;
  };
  getMandatoryGroups = (groupId) => {
    return this.props.mandatoryModules.find(
      (module) => module.moduleGroupId === groupId
    );
  };
  onDragEnd = (result) => {
    const { semester } = this.props.match.params;
    const uid = this.state.modules.find(
      (module) => module.uid == result.draggableId
    ).uid;

    const state = {
      selected: clone(this.state.selected),
      dropzone: clone(this.state.dropzone),
    };

    // only set new state if the item was dropped in the selected area
    if (
      result.destination &&
      result.source.droppableId !== result.destination.droppableId
    ) {
      if (result.destination.droppableId.includes('selected-')) {
        state.selected.push(uid);
        state.dropzone[result.destination.droppableId] = uid;
      }
      if (result.source.droppableId.includes('selected-')) {
        state.selected.splice(this.state.selected.indexOf(uid), 1);
        state.dropzone[result.source.droppableId] = null;
      }
      this.setState(state);
      setSessionModules(state, semester);
      this.props.onModuleChange(semester, state.dropzone);
    }
    this.setState({ dragging: null });
  };
  onDragStart = (result) => {
    const modules = this.props.modules.filter((group) => {
      return !!group.coreElectiveModules.find(
        (module) => module.uid.toString() === result.draggableId
      );
    });
    this.setState({
      dragging: result,
      currentTypes: modules.map((module) => module.uid),
    });
  };
  selectableModules = () => {
    const groups = this.getInactiveModulesGrouped();
    return Object.keys(groups).map((key) => {
      const mandatoryModules = this.getMandatoryGroups(groups[key].uid);
      const activeModules = this.getActiveModulesGrouped();
      const numberOfActiveModules =
        activeModules[key] !== undefined
          ? activeModules[key].modules.length
          : 0;

      return (
        <div key={key}>
          <h4>
            {key}{' '}
            {mandatoryModules
              ? `(${numberOfActiveModules} / ${mandatoryModules.amount})`
              : ''}
          </h4>
          <Droppable droppableId={`list-${key}`}>
            {(provided) => (
              <div
                className="space-y-sm"
                ref={provided.innerRef}
                {...provided.droppableProps}
              >
                {provided.placeholder}
                {groups[key].modules.map((module, index) => {
                  const isInactive =
                    this.state.selectedModules.includes(module.uid) ||
                    !this.groupIsSatisfied(groups[key].uid, key);
                  return (
                    <DraggableModule
                      module={module}
                      moveIcon={true}
                      key={module.uid}
                      index={index}
                      height={[100, 'auto']}
                      inactive={isInactive}
                    />
                  );
                })}
              </div>
            )}
          </Droppable>
        </div>
      );
    });
  };
  selectedModule = (zone) => {
    const module = this.state.modules.find(
      (module) => this.state.dropzone[zone] === module.uid
    );

    if (module) {
      return (
        <DraggableModule
          module={module}
          index={module.uid}
          height={['auto', '100%']}
          selected={true}
        />
      );
    }
    return null;
  };
  dropZones = () => {
    return (
      <>
        <div>
          {localize(
            'modulePlaceholderDescription',
            this.props.match.params.semester
          )}
        </div>
        <div className="row row--with_margin">
          {this.props.modules.map((module, key) => {
            const zoneId = `selected-${module.uid}`;
            const isDragDisabled = !!this.state.dropzone[zoneId];
            const isAllowed = this.state.currentTypes.includes(module.uid);

            return (
              <div
                key={module.uid}
                className={classNames('col-12 mb-2', {
                  'col-sm-6': this.props.modules.length > 1,
                })}
              >
                <Droppable
                  droppableId={zoneId}
                  key={module.uid}
                  isDropDisabled={isDragDisabled || !isAllowed}
                >
                  {(provided, snapshot) => (
                    <div
                      className={classNames(
                        'placeholder-container position-relative',
                        {
                          'drop-active': snapshot.isDraggingOver,
                          'drop-allowed': this.state.dragging && isAllowed,
                        }
                      )}
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                    >
                      {this.selectedModule(`selected-${module.uid}`)}
                      <div className="placeholder p-3">
                        {localize('modulePlaceholder', key + 1)}
                      </div>
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  render() {
    const styles = {
      maxHeight: this.state.dropzoneHeight
        ? `calc(100vh - ${this.state.dropzoneHeight}px - 65px - 50px - 50px)`
        : null,
    };

    return (
      <DragDropContext
        onDragEnd={this.onDragEnd}
        onDragStart={this.onDragStart}
      >
        <TwoColumns
          left={
            <div className="space-y selectable-modules">
              {this.selectableModules()}
            </div>
          }
          right={<div className="dropzones">{this.dropZones()}</div>}
          className={'elective-module-container'}
          style={styles}
        />
      </DragDropContext>
    );
  }
}

export default withRouter(ElectiveModules);
